import {
  Add16Filled,
  DataTrendingRegular,
  RibbonRegular,
} from "@fluentui/react-icons";
import { AppSpinner } from "components/AppSpinner/AppSpinner";
import { BenefitCardOrderSubmit } from "components/BenefitCardOrderSubmit/BenefitCardOrderSubmit";
import { BenefitCategoryDialog } from "components/BenefitCategoryDialog/BenefitCategoryDialog";
import {
  ActionButton,
  StyledTab,
  StyledTabList,
  ToolbarContainer,
} from "components/styled";
import { useRoleType } from "hooks/useRoleType";
import { useAtom } from "jotai";
import { EAdminTabView, IBenefitCategory } from "library/types";
import { useCallback, useState } from "react";
import { useTranslation } from "react-i18next";
import { selectedAdminTabState } from "store";
import { orderedBenefitCategoriesAtom } from "store/UIAdminPage";
import styled from "styled-components";
import { ManageImages } from "./ManageImages/ManageImages";

type Props = {
  searchActive: boolean;
  benefitCategories: IBenefitCategory[];
  searchFilterValue?: string;
};

export function AdminPageToolbar({
  searchActive,
  benefitCategories,
  searchFilterValue,
}: Props) {
  const { t } = useTranslation();
  const [addBenefitOpen, setAddBenefitOpen] = useState(false);
  const roles = useRoleType();

  const isReadOnlyUser = !roles?.hasAdminRole;

  const handleAddBenefitDialogState = useCallback((state) => {
    setAddBenefitOpen(state);
  }, []);

  const [selectedAdminPageTab, setSelectedAdminPageTab] = useAtom(
    selectedAdminTabState
  );

  const benefitKey = `${0}-${0}-category`;

  return (
    <ToolbarContainer>
      <LeftItems>
        <StyledTabList
          selectedValue={selectedAdminPageTab}
          onTabSelect={(e, data) => {
            setSelectedAdminPageTab(data.value as EAdminTabView);
          }}
        >
          <StyledTab icon={<RibbonRegular />} value={EAdminTabView.benefits}>
            {t("hbh.benefits.label")}
          </StyledTab>
          <StyledTab
            icon={<DataTrendingRegular />}
            value={EAdminTabView.analytics}
          >
            {t("hbh.analytics.label")}
          </StyledTab>
        </StyledTabList>
      </LeftItems>
      <RightItems>
        <BenefitCardOrderSubmit
          disabled={searchActive}
          itemList={benefitCategories || []}
          settingKey={benefitKey}
          orderedAtom={orderedBenefitCategoriesAtom}
          searchFilterValue={searchFilterValue}
          itemIdProperty="benefitCategoryTag"
        />
        <ManageImages />
        <ActionButton
          noBorder
          disabled={isReadOnlyUser}
          appearance="subtle"
          icon={<Add16Filled />}
          onClick={() => {
            setAddBenefitOpen(true);
          }}
        >
          {t("hbh.addBenefitCategory.label")}
        </ActionButton>
      </RightItems>

      {addBenefitOpen && (
        <BenefitCategoryDialog
          countryCode={0}
          open={addBenefitOpen}
          setOpen={handleAddBenefitDialogState}
        />
      )}
    </ToolbarContainer>
  );
}

const LeftItems = styled.div`
  display: flex;
  align-items: center;
`;
const RightItems = styled.div`
  display: flex;
  align-items: center;
`;
